export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5310.e6c337f4.jpg";